import { configureStore } from '@reduxjs/toolkit';
import { routerSlice, routerState } from "./slices/router";
import { qrSlice, qrState } from "./slices/qr";
import { authParamsSlice, authParamsState } from "./slices/authParams";
import { mfaDialogSlice, mfaDialogState } from "./slices/mfaDialog";
import { factorSelectionSlice, factorSelectionState } from "./slices/factorSelection";
import { errorModalSlice, errorModalState } from "./slices/errorModal";
export { initStore, getStore, resetStore };
export var initialState = {
  router: routerState,
  qr: qrState,
  authParams: authParamsState,
  mfaDialog: mfaDialogState,
  factorSelection: factorSelectionState,
  error: errorModalState
};
function initStore() {
  var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  return configureStore({
    preloadedState: preloadedState,
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware().concat([function (_api) {
        return function (next) {
          return function (action) {
            try {
              if (window.location.search.indexOf('MFA_BY_APP') == -1) {
                next(action);
                return;
              }
            } catch (e) {
              next(action);
              return;
            }
            console.info("MfaDialog Action", action);
            next(action);
          };
        };
      }]);
    },
    reducer: {
      router: routerSlice.reducer,
      qr: qrSlice.reducer,
      authParams: authParamsSlice.reducer,
      mfaDialog: mfaDialogSlice.reducer,
      factorSelection: factorSelectionSlice.reducer,
      error: errorModalSlice.reducer
    }
  });
}
function getStore() {
  return store;
}
function resetStore() {
  store = initStore();
}
var store = initStore();
// Infer the `RootState` and `AppDispatch` types from the store itself

// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}